<template>
  <div class="tile licensed--locations">
    <p class="text__bold text__center">Licensed Locations</p>
    <div v-if="!editing">
      <p
        v-if="!active.licensed_locations || active.licensed_locations.length === 0"
        class="flex__center lender--placeholder"
      >{{ active.display_name }} is not licensed at any locations</p>
      <div v-else>
        <p
          class="text__center m-tb-small"
        >{{ active.display_name }} is licensed at the following locations</p>
        <simplebar class="lender--overflow" data-simplebar-auto-hide="false">
          <ul class="locations--list-show">
            <li
              v-for="location in active.licensed_locations"
              :key="location._id"
              class="lender--list-item"
            >
              <span class="text__dark">&bull;</span>
              <p>
                {{ location.address.city }} - {{ location.address.state }}
                <br />
                <span class="text__small">({{ location.address.street }})</span>
              </p>
            </li>
          </ul>
        </simplebar>
      </div>
    </div>
    <div v-else class="lender--edit m-tb-small">
      <label class="flex__center">
        Search:
        <input
          type="text"
          v-model="locationSearch"
          name="locationSearch"
          placeholder="location"
          class="list--search ml-10"
          ref="search"
        />
      </label>
      <simplebar class="lender--overflow" data-simplebar-auto-hide="false">
        <ul class="lender--edit-list">
          <li class="lender--edit-item" v-for="location in filteredLocations" :key="location._id">
            <input
              class="locations--list-check"
              type="checkbox"
              :value="location._id"
              v-model="form.licensed_locations"
              :name="location.url"
              :id="location.url"
            />
            <label :for="location.url">
              {{ location.address.city }} - {{ location.address.state }}
              <br />
              <span class="text__small">({{ location.address.street }})</span>
            </label>
          </li>
        </ul>
      </simplebar>
    </div>
    <div v-if="!editing" class="flex__center pt-15">
      <button class="btn btn__green" @click="toggleEditing">Edit</button>
    </div>
    <div v-else class="flex__between pt-15">
      <button class="btn btn__red" @click="toggleEditing">Cancel</button>
      <button class="btn btn__green" @click="submitLocations">Submit</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["active"],
  data() {
    return {
      editing: false,
      locationSearch: "",
      form: {
        _id: this.active._id,
        licensed_locations: this.active.licensed_locations
          ? this.active.licensed_locations.map(location => location._id)
          : []
      }
    };
  },
  computed: {
    ...mapGetters({
      getLocations: "loanOfficers/getLocations"
    }),
    filteredLocations() {
      if (this.locationSearch) {
        return this.getLocations.filter(location => {
          return `${location.address.street} ${location.address.city} ${location.address.state} ${location.address.zip}`
            .toLowerCase()
            .includes(this.locationSearch.toLowerCase());
        });
      } else {
        return this.getLocations;
      }
    }
  },
  methods: {
    ...mapActions({
      startUpdateLoanOfficer: "loanOfficers/startUpdateLoanOfficer"
    }),
    toggleEditing() {
      this.locationSearch = "";
      this.editing = !this.editing;
      this.$nextTick(() => {
        return this.editing ? this.$refs.search.focus() : null;
      });
    },
    async submitLocations() {
      if (this.active) {
        await this.startUpdateLoanOfficer(this.form);
        this.toggleEditing();
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>